import { stringify } from 'query-string';
/**
 * https に置き換え
 * @param {string} _url
 * @returns {string} 変換後のURL
 */
export const normalizeProtocol = (_url) => {
    const url = new URL(_url);
    if (url.protocol !== 'https:') {
        url.protocol = 'https:';
    }
    return url.toString();
};
/**
 * www. が含まれる場合 www. 削除
 * @param {string} _url
 * @returns {string} 変換後のURL
 */
export const normalizeDomain = (_url) => {
    const url = new URL(_url);
    if (url.hostname.indexOf('www.') !== -1) {
        url.hostname = url.hostname.replace('www.', '');
    }
    return url.toString();
};
/**
 * パラメータのない URL 取得
 * @param {string} _url
 * @returns {string} 変換後のURL
 */
export const getUrlWithoutParameter = (_url) => {
    const url = new URL(_url);
    url.search = '';
    url.hash = '';
    return url.toString();
};
/**
 * URLをcanonical タグの値に適切なものに変換
 * @param {string} url
 * @param {{*}} query
 * @returns {string} 変換後のURL
 */
export const convertForCanonicalUrl = (url, query = null) => {
    let canonicalUrl = url;
    canonicalUrl = normalizeProtocol(canonicalUrl);
    canonicalUrl = normalizeDomain(canonicalUrl);
    canonicalUrl = getUrlWithoutParameter(canonicalUrl);
    return query ? `${canonicalUrl}?${stringify(query)}` : canonicalUrl;
};
